"use client";

import Logo from "../../public/logo-evanhub.svg";
import Image from "next/image";
import { useLanguage } from "@/app/api/LanguageContext";

const Loading = () => {
  const { locale } = useLanguage();

  return (
    <div className="loading_data">
      <div className="loading__container">
        <div className="loading__container__text">
          <Image
            src={Logo}
            width={122}
            height={43}
            alt="Logo Evanhub"
            className="logo-loading"
          />
          <p className="text-center">
            {locale === "es" ? "Cargando..." : "Loading..."}
          </p>
        </div>
      </div>
    </div>
  );
};

export default Loading;
